import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconText2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconText2"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3.5C3 3.22386 3.22386 3 3.5 3H19.5C19.7761 3 20 3.22386 20 3.5C20 3.77614 19.7761 4 19.5 4H12V20.5C12 20.7761 11.7761 21 11.5 21C11.2239 21 11 20.7761 11 20.5V4H3.5C3.22386 4 3 3.77614 3 3.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconText2;
